module.exports = __webpack_public_path__ + "images/emoji/anger.1a8fc881f277d6b5c7a7.png";